import { render, staticRenderFns } from "./selfPriceTable.vue?vue&type=template&id=4db01ab8"
import script from "./selfPriceTable.vue?vue&type=script&lang=js"
export * from "./selfPriceTable.vue?vue&type=script&lang=js"
import style0 from "./selfPriceTable.vue?vue&type=style&index=0&id=4db01ab8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports